import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { automationImages } from '@images/automation-images';
import { commonImages } from '@images/common-images';
import { Pagination } from '@models/pagination.model';
import { ApiService } from '@services/api/api.service';
import { WorkflowService } from '@services/api/workflow.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { Utils } from '@services/helpers/utils';
import { ToastrService } from 'ngx-toastr';
import { Paginator } from 'primeng/paginator';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-workflow-processes',
  templateUrl: './workflow-processes.component.html',
  styleUrls: ['./workflow-processes.component.scss'],
})
export class WorkflowProcessesComponent implements OnInit {
  ActivatedModule: any = null;
  SpecificModuleListing: any[] = [];
  ProjectsUnits: any = { selected: ([] = []), allunits: [] };
  ProcessList: any[] = [];
  Utils = Utils; // 👈 expose Utils class to the template
  tempProcessList: any[] = [];
  isLoading: boolean = true;
  process_history: boolean = false;
  processPagination: Pagination;
  first: number = 0;
  numberOfRecords: number = 5;
  images = automationImages;
  common_images = commonImages;

  @Input() process_panel: Observable<any> = null;
  @Input() active_module: any = null;
  @Output() CloseProcessPane: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateFilterProcess: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  processModule = '';
  constructor(
    private _workflowService: WorkflowService,
    private api: ApiService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.process_panel.subscribe(response => {
      this.isLoading = true;
      if (response) {
        // Get the office trigger by id when the process panel is opened
        try {
          this.tempProcessList = this.ProcessList = [];
          this._workflowService.GetOfficeTriggerById(this.active_module?._id).subscribe(response => {
            try {
              const { status, data } = response;
              if (status) {
                // Update the task list and the projects units with the active module
                this._workflowService.TaskList.data = this._workflowService.TaskList?.data?.map(res => {
                  if (res?._id == data?._id) {
                    res = this.active_module = data;
                    this.ProjectsUnits.selected = data?.projects || [];
                  }
                  return res;
                });
                if (this.active_module) {
                  // Trigger the applied list with the active module
                  this.ActivatedModule = JSON.stringify(this.active_module);
                  this.TriggerAppliedList(this.active_module?.module);
                }
              }
              this.isLoading = false;
            } catch (error) {
              this.toastr.error('Something went wrong');
            }
          });
        } catch (_error) {}
      }
    });
  }

  workflow_history = [];

  getWorkFlowHistory(process) {
    // Show the workflow history dialog with workflow history data for the selected process
    this.process_history = true;
    this.api
      .get(`/workflow-history?workflow_id=${this.active_module?._id}&office_id=${this.api.getOfficeId()}&process_record=${process?._id}`)
      .subscribe(res => {
        if (res['status'] === true) {
          // Store the workflow history data in the component variable
          this.workflow_history = res?.data;
        }
      });
  }

  rows: number = 15;
  scrollTop: number = 0;
  @ViewChild('scrollableElement') scrollableElement!: ElementRef;
  scrollToTop(): void {
    // Scroll the content to the top of the scrollable element.
    // - Sets the scrollTop property of the element to 0.
    const element = this.scrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onScroll(event: Event): void {
    const element = event.target;
    this.scrollTop = element['scrollTop'];
    let a: any = element['scrollHeight'] - element['scrollTop'];
    let b: any = element['scrollHeight'] - element['scrollTop'];
    let c = element['clientHeight'];
    // Check if the user has scrolled to the bottom of the div
    // and if the loading variable is true
    // then increase the page number and call the GetProcessByModules with the new page number
    if ((parseInt(a) - 5 < parseInt(c) || parseInt(b) == parseInt(c)) && this.ProcessList?.length > this.rows) {
      this.rows = this.rows + 15;
      if (this.ProcessList?.length < this.rows) {
        this.rows = this.ProcessList?.length;
      }
    }
  }

  SetupProcessList = (trigger: any) => {
    this.isLoading = true;
    this.ProcessList = [];
    try {
      // Add filter logic for the workflows for the selected module
      const { filter } = trigger;
      if (filter?.filter(res => res._id == 'all')?.length > 0) {
        // If the all checkbox is checked, set the process status to the same as the all checkbox
        this.ProcessList = this.SpecificModuleListing?.map(res => ({
          ...res,
          module: Utils.capitalizePhrase(trigger?.module?.split('_')?.join(' ')?.trim() || ''),
          process: filter?.filter(res => res._id == 'all')?.[0]?.process,
        }));
        // Loop through the ProcessList and update the process status to the same as the corresponding filter element
        this.ProcessList.forEach(value => {
          filter?.forEach(element => {
            if (value?._id == element?._id) {
              value.process = element.process || filter?.filter(res => res._id == 'all')?.[0]?.process;
            }
          });
        });
        this.tempProcessList = this.ProcessList;
      } else {
        // If the all checkbox is not checked, loop through the SpecificModuleListing and the filter and add the process status to the ProcessList
        this.SpecificModuleListing.forEach(value => {
          filter?.forEach(element => {
            if (value?._id == element?._id) {
              this.ProcessList.push({
                ...value,
                module: Utils.capitalizePhrase(trigger?.module?.split('_')?.join(' ')?.trim() || ''),
                process: element?.process,
              });
            }
          });
        });
        this.tempProcessList = this.ProcessList;
      }
      // Set the pagination variables
      this.processPagination = {
        ...this.processPagination,
        per_page: 5,
        total_pages: Math.ceil(this.tempProcessList?.length / 5),
        total: this.tempProcessList?.length,
      };
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  };

  TriggerAppliedList(moduleName = '') {
    this.isLoading = true;
    this.tempProcessList = this.ProcessList = [];
    this.SpecificModuleListing = [];
    if (moduleName?.toLowerCase() == 'listing' || moduleName?.toLowerCase() == 'properties') {
      if (moduleName?.toLowerCase() == 'properties') {
        this.processModule = 'Listings';
      } else {
        this.processModule = 'Properties';
      }
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLisitingModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [
              ...this.SpecificModuleListing,
              { _id: 'all', property_address: 'All', module: moduleName },
              ...response?.data,
            ]?.map(result => ({ ...result, name: result?.property_address }));

            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'properties' || moduleName?.toLowerCase() == 'properties_data') {
      if (moduleName?.toLowerCase() == 'properties') {
        this.processModule = 'Listings';
      } else {
        this.processModule = 'Properties';
      }
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetPropertyModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [
              ...this.SpecificModuleListing,
              { _id: 'all', property_address: 'All', module: moduleName },
              ...response?.data,
            ]?.map(result => ({ ...result, name: result?.property_address }));

            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'projects') {
      this.processModule = 'Projects';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [
              ...this.SpecificModuleListing,
              { _id: 'all', Project_Name: 'All', module: moduleName },
              ...response?.data,
            ]?.map(result => ({ ...result, name: result?.Project_Name }));
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'contacts') {
      this.processModule = 'Contacts';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetContactModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [
              ...this.SpecificModuleListing,
              { _id: 'all', full_name: 'All', module: moduleName },
              ...response?.data,
            ]?.map(result => ({ ...result, name: result?.full_name }));
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'tasks') {
      this.processModule = 'Tasks';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetTaskModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', title: 'All', module: moduleName }, ...response?.data]?.map(
              result => ({ ...result, name: result?.title })
            );
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'lead_management') {
      this.processModule = 'Leads';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLeadManagementModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [
              ...this.SpecificModuleListing,
              { _id: 'all', first_name: 'All', module: moduleName },
              ...response?.data,
            ]?.map(result => ({ ...result, name: result?.first_name }));
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName?.toLowerCase() == 'library') {
      this.processModule = 'Library';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLibraryModuleListDetail().subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', title: 'All', module: moduleName }, ...response?.data]?.map(
              result => ({ ...result, name: result?.title })
            );
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else if (moduleName == 'project_units') {
      this.processModule = 'Project Units';
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectUnitsModuleListDetail(this.active_module?.projects, this.active_module?._id).subscribe(
        response => {
          if (response?.['status']) {
            // add 'All' to the beginning of the list
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', lot_name: 'All', module: moduleName }, ...response?.data]?.map(
              result => ({
                ...result,
                name: result?.lot_name,
                tag_labeled_slug:
                  result?._id === 'all'
                    ? 'All'
                    : this.ProjectsUnits?.allunits
                        ?.filter(localapart => localapart?._id == result?.projectid)?.[0]
                        ?.['Project_Name']?.toUpperCase() || '',
              })
            );
            this.SetupProcessList(JSON.parse(this.ActivatedModule));
          }
        },
        _ => {
          this.SpecificModuleListing = [];
        }
      );
    } else {
      this.processModule = '';
      this.SpecificModuleListing = [];
    }
    this.isLoading = false;
  }

  closePane() {
    // Emit an event to close the process pane
    this.CloseProcessPane.emit(true);
  }

  FilterSearchProcessList(value) {
    if (value) {
      // Filter the process list based on the search value
      this.ProcessList = this.tempProcessList.filter(val => {
        let startsWithCondition =
          val?.name?.toLowerCase().startsWith(value.toLowerCase()) || val?.tag_labeled_slug?.toLowerCase().startsWith(value.toLowerCase());
        let includesCondition =
          val?.name?.toLowerCase().includes(value.toLowerCase()) || val?.tag_labeled_slug?.toLowerCase().includes(value.toLowerCase());
        if (startsWithCondition) {
          return startsWithCondition;
        } else if (!startsWithCondition && includesCondition) {
          return includesCondition;
        } else return null;
      });
    } else {
      // Reset the process list to its original state
      this.ProcessList = this.tempProcessList;
      const { paginatorState } = this.paginator;
      const { first, rows } = paginatorState;
      this.first = first;
      this.numberOfRecords = rows;
    }
  }
  ChangeProcessStatus(process) {
    // Toggle the status of all processes when the all process is toggled
    if (process?._id == 'all') {
      let status = process?.process === 'play' ? 'stop' : 'play';
      this.ProcessList?.forEach(pro => {
        pro.process = status;
      });
    } else {
      // Toggle the status of an individual process
      process.process = process?.process === 'play' ? 'stop' : 'play';
    }
    // Determine which processes to include in the update
    let data: any = null;
    if (this.ProcessList.filter(res => res.process == 'play')?.length === this.ProcessList.length) {
      // If all processes are set to play, only include the all process in the update
      data = [{ _id: 'all', process: 'play' }];
    } else if (this.ProcessList.filter(res => res.process == 'stop')?.length === this.ProcessList.length) {
      // If all processes are set to stop, only include the all process in the update
      data = [{ _id: 'all', process: 'stop' }];
    } else if (this.ProcessList.filter(res => res._id == 'all')?.length > 0) {
      // If the all process is included, include it in the update, along with any processes that have a different status
      let status = this.ProcessList.filter(res => res._id == 'all')?.[0]?.process;
      data = [
        ...[{ _id: 'all', process: status }],
        ...this.ProcessList.filter(res => res?.process !== status)?.map(res => ({ _id: res?._id, process: res?.process })),
      ];
    } else {
      // If the all process is not included, include all processes in the update
      data = this.ProcessList;
    }
    // Update the trigger with the new filter
    this.triggerEditPublish(data);
  }

  triggerEditPublish(filter) {
    // Update the trigger with the new filter
    let data = { ...JSON.parse(this.ActivatedModule), filter: filter };
    if (!data) {
      return;
    }
    let id = data?._id;
    this.api.put('/workflow/update/' + id, data).subscribe({
      next: response => {
        if (response['status'] === true) {
          // Update the list of all triggers
          this.getTrigger();
          // Update the filter of the processes pane
          this.updateFilterProcess.emit(data);
          // Reset the selected projects and units
          this.SpecificModuleListing = this.ProjectsUnits.selected = this.ProjectsUnits.allunits = [];
          this.toastr.success(response.message);
        }
      },
    });
  }

  getTrigger() {
    // Fetch tasks related to the current office
    let officeId = Crypto.decrypt(localStorage.getItem('officeid'));
    this._workflowService.GetTriggerByOffices(officeId).subscribe({
      next: response => {
        // Store the tasks in the workflow service
        this._workflowService.TaskList = response.data;
      },
    });
  }
}
